module.exports = __webpack_public_path__ + "img/loading.e4ade380.gif";